import { getAllRoles } from "../../../../queries/tenant-setting/use-get-roles-previllage-list";
import { GetAllRoleRoleTypeEnum } from "../../../../services/api";
import { getXtenantId } from "../../../../utils/utils";
import { RoleType, SELECT_ROLE_OPTIONS } from "./rolesResponsibility";

interface UseRoleOptionsProps {
  enabled: boolean;
  pgiD: string;
  roleView: RoleType;
}

const useRoleOptions = ({ enabled, pgiD, roleView }: UseRoleOptionsProps) => {
  const { data: rolesData } = getAllRoles({
    pagination: { page: 0, pageSize: 50 },
    xTENANTID: getXtenantId() ?? pgiD ?? undefined,
    status: true,
    archive: false,
    roleType: SELECT_ROLE_OPTIONS[roleView]?.map(
      (role) => role?.value
    ) as GetAllRoleRoleTypeEnum[],
    enabled: enabled,
  });

  return {
    rolesData: [
      ...(rolesData?.data?.content?.map((role) => ({
        value: role.name,
        label: role.name,
        type: role.type,
      })) ?? []),
    ],
  };
};

export default useRoleOptions;
